import { render, staticRenderFns } from "./batchConfigurationNew.vue?vue&type=template&id=7da15b4d&"
import script from "./batchConfigurationNew.vue?vue&type=script&lang=js&"
export * from "./batchConfigurationNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports